var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdddevicePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9231 5.92308C15.9231 5.41538 15.5077 5 15 5C14.4923 5 14.0769 5.41538 14.0769 5.92308V16.0769H3.92308C3.41538 16.0769 3 16.4923 3 17C3 17.5077 3.41538 17.9231 3.92308 17.9231H14.0769V28.0769C14.0769 28.5846 14.4923 29 15 29C15.5077 29 15.9231 28.5846 15.9231 28.0769V17.9231H26.0769C26.5846 17.9231 27 17.5077 27 17C27 16.4923 26.5846 16.0769 26.0769 16.0769H15.9231V5.92308Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9231 5.92308C15.9231 5.41538 15.5077 5 15 5C14.4923 5 14.0769 5.41538 14.0769 5.92308V16.0769H3.92308C3.41538 16.0769 3 16.4923 3 17C3 17.5077 3.41538 17.9231 3.92308 17.9231H14.0769V28.0769C14.0769 28.5846 14.4923 29 15 29C15.5077 29 15.9231 28.5846 15.9231 28.0769V17.9231H26.0769C26.5846 17.9231 27 17.5077 27 17C27 16.4923 26.5846 16.0769 26.0769 16.0769H15.9231V5.92308Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdddevicePlusIcon);
export default __webpack_public_path__ + "static/media/adddevice-plusIcon.113b3b978bbaf70fa18c39cfd3c50304.svg";
export { ForwardRef as ReactComponent };